import React from 'react'
import Breadcrumb from '../../../components/breadcrumb/breadcrumb'
import Hero from '../../../components/hero-v2/hero'
import TabsCustomLinks from '../../../components/tabsCustomLinks/tabsCustomLinks'
import Layout from '../../../components/layouts/layout'
import { ChartLine } from '../../../svg/chart_line'
import { ArrowUpdate } from '../../../svg/arrow_update'
import { ChartLineVertical } from '../../../svg/chart_line_vertical'
import { Diamond } from '../../../svg/diamond'
import Helmet from 'react-helmet'

const Container = props => {
  const titlesBreadcrumb = {
    titlesIntermediate: [
      {
        index: 0,
        title: 'Soy afiliado',
        link: ''
      },
    ],
    titleFinal: 'Empezando a aportar'
  }

  const menu = [
    {
      index: 0,
      hash: '/aportes-y-fondo/tipos-de-fondo',
      title: 'Tipos de fondo',
      icon: ChartLine,
    },
    {
      index: 1,
      hash: '/aportes-y-fondo/tipos-de-fondo/cambia-de-fondo',
      title: 'Cambia de fondo',
      icon: ArrowUpdate,
    },
    {
      index: 2,
      hash: '/aportes-y-fondo/tipos-de-fondo/resultados-de-fondo',
      title: 'Resultados de fondo',
      icon: ChartLineVertical,
    },
    {
      index: 3,
      hash: '/aportes-y-fondo/tipos-de-fondo/valor-real-y-nominal',
      title: 'Valor real y nominal',
      icon: Diamond,
    },
  ]

  return (
    <Layout>
      <Helmet>
        <title>Información sobre los Tipos de Fondo | Prima AFP</title>
        <meta name='title' content='Información sobre los Tipos de Fondo | Prima AFP' data-react-helmet="true" />
        <meta name='description' content='Descubre que son los tipos de fondo, cual es la caracteristica de cada uno y cual es el tipo de fondo que se ajusta mejor a ti con Prima AFP.' data-react-helmet="true" />
        <link rel="canonical" href="https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-fondo/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",  "item": "https://www.prima.com.pe/public-zone/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Aportes y Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Tipos de Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-fondo/"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      <Hero
        preTitle={'Soy afiliado '}
        title='Tipos de fondo'
        highlighted='y sus resultados'
        image={'woman-with-laptop-calendar.svg'}
        imageClassName={'tw-mr-20@lg'}
        imageMobile={'aportes-y-fondo/tipos-de-fondo/bg-banner-tipos-de-fondo-mobile.svg'}
        imageBanner={'aportes-y-fondo/tipos-de-fondo/bg-banner-tipos-de-fondo.svg'}
        description='Conoce más sobre los fondos que disponen para tí y que beneficios te brinda cada uno.'
        arrowDown={true}
        className={'bg-yellow-1'}
      />

      <Breadcrumb GTMLink='/aportes-y-fondo/tipos-de-fondo/' GTMSection='tipos de fondo' GTMTitle='Tipos de fondo y sus resultados' GtmContainer='GTM-MOD-MEP-SECTION-TF-BREADCRUMB' GtmBeforeArrow='GTM-MOD-MEP-SECTION-TF-BREADCRUMB-BEFORE' GtmAfterArrow='GTM-MOD-MEP-SECTION-TF-BREADCRUMB-AFTER' titlesBreadcrumb={titlesBreadcrumb}/>

      <section className="tw-pt-6 tw-pt-8@lg">
        <TabsCustomLinks GTMSection='tipos de fondo' GTMTitle='Tipos de fondo y sus resultados'data={menu} active={props.active} />
        {props.children}
      </section>
    </Layout>
  )
}

export default Container
